import { format, getTime, formatDistanceToNow, parseISO } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}

export function fDateRange(startDate, endDate) {
  const start = new Date(startDate);
  const end = new Date(endDate);

  const startMonth = format(start, 'MMM').toUpperCase();
  const endMonth = format(end, 'MMM').toUpperCase();
  const startDay = format(start, 'd');
  const endDay = format(end, 'd');

  if (startMonth === endMonth) {
    return `${startMonth} ${startDay} - ${endDay}`;
  } else {
    return `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
  }
}

const getOrdinal = (day) => {
  if (day > 3 && day < 21) return `${day}th`;
  switch (day % 10) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
};

export const getEventDurationString = (startDate, endDate) => {
  const start = parseISO(startDate);
  const end = parseISO(endDate);

  const startDay = getOrdinal(parseInt(format(start, 'd')));
  const endDay = getOrdinal(parseInt(format(end, 'd')));
  const monthYear = format(end, 'MMMM, yyyy');

  return `${startDay} - ${endDay} ${monthYear}`;
};
